<template>
  <div class="vx-row" v-if="dashboardData.length">
    <div
      class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
      v-for="(dataDashboard, index) in dashboardData"
      :key="index"
    >
      <statistics-card-line
        :icon="dataDashboard.key ? icons[dataDashboard.key] : 'StarIcon'"
        :statistic="dataDashboard.value | k_formatter"
        :statisticTitle="dataDashboard.key"
        type="area"
        :chartData="chartData"
        :color="color[index]"
      />
    </div>
  </div>
</template>
<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
export default {
  components: {
    StatisticsCardLine
  },
  data() {
    return {
      dashboardData: [],
      chartData: [
        {
          name: "Subscribers",
          data: [28, 40, 36, 52, 38, 60, 55]
        }
      ],
      color: ["success", "danger", "warning", "primary"],
      icons: {
        Users: "UsersIcon",
        Leads: "UserPlusIcon",
        Projects: "SearchIcon",
        Vessels: "AnchorIcon",
        "Total Projects": "SearchIcon",
        "Closed projects": "XOctagonIcon",
        "Closed Projects": "XOctagonIcon",
        "Approved Projects": "CheckCircleIcon",
        "Assigned Projects": "FileTextIcon"
      }
    };
  },
  mounted() {
    this.getDashboardData();
  },
  methods: {
    async getDashboardData() {
      let response = await this.getHTTPPostResponse("/dashboard/matrix");
      if (response) {
        let data = response.data;
        this.dashboardData = data["matrix"];
      }
    }
  }
};
</script>
